var moduleMap = {
	"./ApiApp": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(566)]).then(() => (() => ((__webpack_require__(566)))));
	},
	"./api": () => {
		return __webpack_require__.e(387).then(() => (() => ((__webpack_require__(387)))));
	},
	"./store": () => {
		return Promise.all([__webpack_require__.e(83), __webpack_require__.e(914), __webpack_require__.e(33), __webpack_require__.e(981)]).then(() => (() => ((__webpack_require__(981)))));
	},
	"./ProviderWrapper": () => {
		return Promise.all([__webpack_require__.e(83), __webpack_require__.e(914), __webpack_require__.e(33), __webpack_require__.e(981), __webpack_require__.e(805)]).then(() => (() => ((__webpack_require__(805)))));
	},
	"./Loading": () => {
		return Promise.all([__webpack_require__.e(137), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(899)]).then(() => (() => ((__webpack_require__(280)))));
	},
	"./Sidebar": () => {
		return Promise.all([__webpack_require__.e(137), __webpack_require__.e(340), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(472)]).then(() => (() => ((__webpack_require__(472)))));
	},
	"./PagesHeader": () => {
		return Promise.all([__webpack_require__.e(137), __webpack_require__.e(340), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(364)]).then(() => (() => ((__webpack_require__(364)))));
	},
	"./ShowCustomToast": () => {
		return Promise.all([__webpack_require__.e(137), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(202)]).then(() => (() => ((__webpack_require__(202)))));
	},
	"./LocalStorage": () => {
		return __webpack_require__.e(493).then(() => (() => ((__webpack_require__(493)))));
	},
	"./NotFound": () => {
		return Promise.all([__webpack_require__.e(340), __webpack_require__.e(914), __webpack_require__.e(253)]).then(() => (() => ((__webpack_require__(253)))));
	},
	"./ProjectsSlice": () => {
		return Promise.all([__webpack_require__.e(33), __webpack_require__.e(114)]).then(() => (() => ((__webpack_require__(114)))));
	},
	"./fnxUtils": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(605)]).then(() => (() => ((__webpack_require__(605)))));
	},
	"./NavigationEngine": () => {
		return Promise.all([__webpack_require__.e(914), __webpack_require__.e(216)]).then(() => (() => ((__webpack_require__(216)))));
	},
	"./AuthValidation": () => {
		return __webpack_require__.e(134).then(() => (() => ((__webpack_require__(134)))));
	},
	"./workflow": () => {
		return __webpack_require__.e(846).then(() => (() => ((__webpack_require__(846)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});